import { render } from "./DevcoUpload.vue?vue&type=template&id=35e3c2a8"
import script from "./DevcoUpload.vue?vue&type=script&lang=js"
export * from "./DevcoUpload.vue?vue&type=script&lang=js"

import "./DevcoUpload.vue?vue&type=style&index=0&id=35e3c2a8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__